import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

// Only use index.scss in development mode
// Don't include these styles in the build
// unless you are using the apptest build, which is used by Spin
if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_BUILD_TARGET === 'apptest') {
	import('./index.scss');
}

// Use the REACT_APP_BUILD_TARGET env variable to determine
// which version of the app to display, either "app" or "block".
// The app version is the full page Live Status App.
// The block version is intended to display in a smaller page section.
function importBuildTarget() {
	if (process.env.REACT_APP_BUILD_TARGET === 'app') {
		return import('./App.js');
	} else if (process.env.REACT_APP_BUILD_TARGET === 'block') {
		return import('./Block.js');
	} else if (process.env.REACT_APP_BUILD_TARGET === 'apptest') {
		return import('./App.js');
	} else if (process.env.REACT_APP_BUILD_TARGET === 'log') {
		return import('./Log.js');
	} else {
		return Promise.reject(
			new Error('No such build target: ' + process.env.REACT_APP_BUILD_TARGET)
		);
	}
}

// Import the entry point and render it's default export
importBuildTarget().then(({ default: Environment }) => {
	const root = ReactDOM.createRoot(document.getElementById('root'));
	root.render(
		<React.StrictMode>
			<Environment />
		</React.StrictMode>
	);
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
